<template>
	<div style="padding: 20px"></div>
</template>

<script>
import DOMPurify from "dompurify";
export default {
  props: ["html", "relativeTo"],
  mounted() {
    this.checkUrl(this.html);
  },
  watch: {
    html(newValue) {
      this.checkUrl(newValue);
    }
  },
  methods: {
    checkUrl(html) {
      this.$el.innerHTML = DOMPurify.sanitize(html);
      this.$el.querySelectorAll("a").forEach(el => {
        el.href = this.fixUrl(el.getAttribute("href"));
      });
      this.$el.querySelectorAll("img").forEach(el => {
        el.src = this.fixUrl(el.getAttribute("src"));
        el.loading = "lazy";
        el.style.maxWidth = "100%";
      });
      this.$el.querySelectorAll("iframe").forEach(el => {
        el.src = this.fixUrl(el.getAttribute("src"));
        el.style.maxWidth = "100%";
      });
    },
    fixUrl(url) {
      return new URL(url, this.relativeTo).toString();
    }
  }
}
</script>